<template>
  <b-modal
    id="ccEmail"
    @shown="handleModalShown"
    centered
    size="md"
    close-on-backdrop
    hide-footer
    hide-header-close
  >
    <template #modal-header>
      <div class="addccEmail-header">
        <div class="text-center email-title-cc">
          <h4>Email Categories</h4>
        </div>
      </div>
    </template>
    <b-button variant="close-btn" class='btn-container' @click="closeModal">
      <i class="fas fa-times"></i>
    </b-button>
    <b-container fluid>
      <div class="addRep-form ccEmail-form">
        <form @submit.prevent="onSubmit">
          <div class="form-group mb-3">
            <label class="form-label">Email:</label>
            <input type="text" class="form-control" :value="email" readonly />
          </div>
          <div class="form-group mb-3">
            <label class="form-label">Select Email Categories:</label>
            <div class="checkbox-group">
              <div
                v-for="domain in emailDomains"
                :key="domain.value"
                class="custom-checkbox"
              >
                <input
                  type="checkbox"
                  :id="`checkbox-${domain.value}`"
                  :value="domain.value"
                  v-model="selectedDomains"
                />
                <label :for="`checkbox-${domain.value}`" class="custom-label">
                  {{ domain.text }}
                </label>
                <span v-b-tooltip.hover :title="domain.description">
                  <i
                    class="fas fa-info-circle"
                    style="cursor: pointer; margin-left: 10px; color: #007bff;"
                  ></i>
                </span>
              </div>
            </div>
            <p class="text-info">
              <strong>Note:</strong> By selecting any of the checkboxes, you
              will be included in CC emails for the selected email categories.
            </p>
          </div>
          <div class="form-group text-center mb-3 mt-3">
            <b-button class="univ-btn px-4 py-2" type="submit">
              Apply
            </b-button>
          </div>
        </form>
      </div>
    </b-container>
  </b-modal>
</template>

<script>
import Api from "@/resource/Api";

export default {
  name: "EnableEmail",
  props: {
    email: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      selectedDomains: [],
      updateDomainData: [],
      emailDomains: [],
    };
  },
  methods: {
    closeModal() {
      this.reset();
      this.$emit("onCloseModal");
    },
    reset() {
      this.selectedDomains = [];
      this.$bvModal.hide("ccEmail");
    },
    handleModalShown() {
      this.fetchEmailDomains();
    },
    updateEmailDomains() {
      const url = `v2/get-cc-status`;
      let loader = this.$loading.show();
      Api.get(url)
        .then((res) => {
          let data = res.data.data.find((item) => item.email === this.email);
          let updateDomainData = data.domains;
          const checkedDomains = Object.keys(updateDomainData).filter(
            (domain) => updateDomainData[domain] === 1
          );
          this.selectedDomains = this.emailDomains
            .filter((domain) => checkedDomains.includes(domain.text))
            .map((domain) => domain.value);
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          loader.hide();
        });
    },
    fetchEmailDomains() {
      const url = `v2/email-domains`;
      let loader = this.$loading.show();
      Api.get(url)
        .then((res) => {
          this.emailDomains = res.data.data.map((item) => ({
            text: item.email_category,
            value: item.id,
            description: item.description,
          }));
          this.updateEmailDomains();
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          loader.hide();
        });
    },
    onSubmit() {
      const selectedDomainsIds = new Set(this.selectedDomains);
      const payload = {
        rep_admin_email: this.email,
        domains: this.emailDomains.map((domain) => ({
          email_domain_id: domain.value,
          cc_status: selectedDomainsIds.has(domain.value) ? 1 : 0,
        })),
      };
      this.$emit("onSubmit", payload);
    },
  },
};
</script>
<style>
.email-title-cc {
  width: 100%;
  padding-top: 15px;
  margin-bottom: 0;
  padding-bottom: 0;
}
.ccEmail-form {
  margin-top: -10px;
}
.custom-checkbox-group {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.custom-checkbox input {
  accent-color: #007bff;
  width: 30px;
  height: 30px;
  margin-right: 10px;
  cursor: pointer;
}

.addRep-form .form-label {
  font-size: 16px;
  color: #333;
  font-weight: 500;
  cursor: pointer;
  display: inline-block;
}
.custom-label {
  margin-left: -5px;
  font-size: 15px !important;
}

#ccEmail .btn-container  {
  position: absolute;
  top: -100px !important;
  right: -15px;
  background: #fff;
  color: #000;
  border: 0;
  box-shadow: -2px 2px 13px -4px rgb(0 0 0 / 46%);
  border-radius: 60px;
  font-size: 18px;
  width: 45px;
  height: 45px;
  align-items: center;
  justify-content: center;
  display: flex;
}
</style>
